<template>

  <div>

    <b-card>

        <b-row class="mb-2">

          <b-col sm="6" md="4" class="d-flex align-items-center justify-content-between my-1">
              <date-picker
                  v-model="start_date"
                  placeholder="Start Date"
                  class="f-1"
              /> &nbsp;to&nbsp;
              <date-picker
                  v-model="end_date"
                  placeholder="End Date"
                  class="f-1"
              />
          </b-col>
          <b-col sm="6" md="4" class="my-1">

              <b-form-select v-model=" upload_status ">

                <option value="">-- All Statuses --</option>
                <option value="successful">Where Successful</option>
                <option value="errors">Upload Error</option>
              </b-form-select>
          </b-col>
          <b-col sm="6" md="4" class="my-1">

              <carrier-dropdown v-model=" ltc_carrier_id "></carrier-dropdown>
          </b-col>
          <b-col sm="6" md="4" class="my-1">

              <b-form-input v-model=" filename " placeholder="Search By Filename"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mb-3">

          <b-col sm="12">

            <div class="d-flex align-items-center justify-content-end">

              <b-button variant="info" @click=" loadTable() ">Generate</b-button>
              <b-btn class="ml-3" variant="success" @click="exportXls()">
                <i class="fa fa-file-excel-o"></i> Export to Excel
              </b-btn>
            </div>
          </b-col>
        </b-row>

        <div class="table-responsive">

            <b-table bordered striped hover show-empty
                :items=" items "
                :fields=" fields "
                :current-page=" currentPage "
                :per-page=" 0 "
                :sort-by.sync=" sortBy "
                :sort-desc.sync=" sortDesc "
                :busy=" loading "
            >
                <template v-slot:cell(total_records)="row">
                  <div v-if="row.item.total_records == -1">
                    <span>0</span>
                  </div>
                  <div v-else>
                    <span v-text="row.item.total_records" />
                  </div>
                </template>
                <template v-slot:cell(filename)="row">
                  <div v-if="row.item.can_be_downloaded">
                    <a :href="`${baseUrl}/${row.item.id}`" target="_blank" v-text="row.item.filename" />
                  </div>
                  <div v-else>
                    <span v-text="row.item.filename" />
                  </div>
                </template>
            </b-table>
        </div>

        <b-row>

            <b-col lg="6" >

                <b-pagination :total-rows=" totalRows " :per-page=" perPage " v-model=" currentPage " />
            </b-col>
            <b-col lg="6" class="text-right">

                {{ paginationText }}
            </b-col>
        </b-row>
    </b-card>
  </div>
</template>

<script>

  import PaginatedTable from "../../mixins/PaginatedTable";
  import FormatsDates from "../../mixins/FormatsDates";

  export default {

    mixins: [ PaginatedTable, FormatsDates ],
    data() {

      return {

        baseUrl         : '/business/ip_sync_files',

        start_date      : moment().subtract(1, 'week').format('MM/DD/YYYY'),
        end_date        : moment().format('MM/DD/YYYY'),
        filename        : '',
        upload_status   : '',
        ltc_carrier_id  : '',

        fields : [
          {
            key: 'id',
            label: 'File ID',
            sortable: true,
          },
          {
            key: 'filename',
            label: 'File Name',
            sortable: true,
          },
          {
            key: 'ltc_carrier_id',
            label: 'Block',
            sortable: true,
          },
          {
            key: 'total_records',
            label: 'Total Rows',
            sortable: true,
          },
          {
            key: 'upload_status',
            label: 'Upload Status',
            sortable: true,
          },
          {
            key: 'created_at',
            label: 'Upload Date',
            sortable: true,
            formatter: (value) => { return this.formatDate( value ); }
          },
        ]
      }
    },
    computed: {

      appliedFilters(){ return `?ltc_carrier_id=${this.ltc_carrier_id}&upload_status=${this.upload_status}&start_date=${this.start_date}&end_date=${this.end_date}`; },
      unwatchedFilters(){ return `&filename=${this.filename}`; }
    },
    methods: {

      downloadFile( id ){

        window.open( `${this.baseUrl}/${id}`, '_blank' );
      }
    }
  }
</script>

<style>

</style>
